import AbstractView from '../../utils/abstract-view';
import { render, RenderPosition } from '../../utils/render';

const createVKAuthButtonTemplate = (data, isAuth) => {
  const user = isAuth ? data.payload.user : null;

  return (
    `<button class="button-vk" type="button">
      <svg class="button-vk__icon" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 0c5.7 0 7 1.3 7 7v6c0 5.7-1.3 7-7 7H7c-5.7 0-7-1.3-7-7V7c0-5.7 1.3-7 7-7h6ZM5.3 6.4H3.8c-.5 0-.5.2-.5.4 0 .4.4 2.3 2.3 4.8 1.2 1.7 2.9 2.7 4.4 2.7 1 0 1-.2 1-.6v-1.3c0-.4.1-.5.4-.5.2 0 .6.1 1.5 1 1 1 1.1 1.4 1.7 1.4H16c.5 0 .7-.2.5-.6 0-.4-.6-1-1.2-1.7l-1-1.1c-.2-.3-.1-.4 0-.6.3-.4 1.8-2.6 2-3.4 0-.3 0-.5-.5-.5h-1.4c-.4 0-.6.2-.7.4 0 0-.7 1.8-1.8 3-.3.3-.4.4-.6.4-.1 0-.3-.1-.3-.4V6.9c0-.4 0-.5-.4-.5H8.3c-.2 0-.3.1-.3.3 0 .4.5.4.5 1.4v2.2c0 .4 0 .5-.2.5-.5 0-1.7-1.8-2.4-3.9-.2-.4-.3-.5-.7-.5Z" fill="#07F"/>
      </svg>

      ${isAuth
        ? `<span class="button-vk__text ${!user.phone ? 'button-vk__text--center' : ''} f f--16">Заполнить как ${user.first_name}</span>
          ${user.phone
            ? `<span class="button-vk__tel f f--12">${user.phone}</span>`
            : ''
          }

          <img
            class="button-vk__avatar"
            src="${user.avatar}"
            alt="Аватар пользователя ${user.first_name}"
            loading="lazy"
            width="30"
            height="30"
          >`
        : `<span class="button-vk__text button-vk__text--center f f--16">
             Войти через VK ID
           </span>`
      }
    </button>`
  )
};

export class VKAuthButton extends AbstractView {
  constructor(container, data, isAuth, callback) {
    super();

    this._container = container;
    this._data = data;
    this._isAuth = isAuth;
    this._callback = callback;

    this._clickButtonHandler = this._clickButtonHandler.bind(this);
  }

  init() {
    render(this._container, this.getElement(), RenderPosition.AFTERBEGIN);
  }

  getTemplate() {
    return createVKAuthButtonTemplate(this._data, this._isAuth);
  }

  _clickButtonHandler(evt) {
    evt.preventDefault();
    this._callback();

    const parentBlock = evt.target.closest('[data-block-name]');
    const blockName = parentBlock ? parentBlock.dataset.blockName : 'not-named-block';
    window.$analytics && window.$analytics.push('vk-connect-button-click', {
      blockName
    });
  }

  bind() {
    this.getElement().addEventListener('click', this._clickButtonHandler);
  }

  unbind() {
    this.getElement().removeEventListener('click', this._clickButtonHandler);
  }
}
